import { cn } from '@/lib/utils';
import type { ProntuarioPastSessionTask } from '../../types/prontuarioPastSession';
import { PRONTUARIO_SESSION_DETAIL_LABEL_CLASS } from '../../constants/prontuarioTheme';

type ProntuarioPastSessionTasksListProps = {
	tasks: ProntuarioPastSessionTask[];
	className?: string;
};

const ProntuarioPastSessionTasksList = ({
	tasks,
	className,
}: ProntuarioPastSessionTasksListProps) => {
	if (!tasks.length) return null;

	return (
		<div className={cn('mt-5 space-y-3', className)}>
			<p className={PRONTUARIO_SESSION_DETAIL_LABEL_CLASS}>Tarefas</p>
			<ul className="space-y-2.5">
				{tasks.map((task) => {
					const hasReview =
						task.doneLabel !== 'Pendente' ||
						task.hadDifficultyLabel ||
						task.enjoyedLabel ||
						task.engagementRating != null ||
						task.reviewNotes;

					return (
						<li
							key={task.id}
							className="rounded-xl border border-white/[0.08] bg-[#1a2430] px-3.5 py-3"
						>
							<p className="text-[14px] leading-[1.55] text-[#e8eaed]">
								{task.description}
							</p>
							{hasReview ? (
								<dl className="mt-2.5 space-y-1 text-[13px] leading-snug text-[#9aa0a6]">
									<div className="flex gap-2">
										<dt className="shrink-0">Realizou:</dt>
										<dd className="text-[#bdc1c6]">
											{task.doneLabel}
										</dd>
									</div>
									{task.hadDifficultyLabel ? (
										<div className="flex gap-2">
											<dt className="shrink-0">
												Dificuldade:
											</dt>
											<dd className="text-[#bdc1c6]">
												{task.hadDifficultyLabel}
											</dd>
										</div>
									) : null}
									{task.enjoyedLabel ? (
										<div className="flex gap-2">
											<dt className="shrink-0">
												Gostou / útil:
											</dt>
											<dd className="text-[#bdc1c6]">
												{task.enjoyedLabel}
											</dd>
										</div>
									) : null}
									{task.engagementRating != null ? (
										<div className="flex gap-2">
											<dt className="shrink-0">
												Engajamento:
											</dt>
											<dd className="text-[#bdc1c6]">
												{task.engagementRating}/5
											</dd>
										</div>
									) : null}
									{task.reviewNotes ? (
										<div>
											<dt>Observações:</dt>
											<dd className="mt-0.5 text-[#bdc1c6]">
												{task.reviewNotes}
											</dd>
										</div>
									) : null}
								</dl>
							) : (
								<p className="mt-2 text-[13px] text-[#9aa0a6]">
									Revisão pendente
								</p>
							)}
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export { ProntuarioPastSessionTasksList };
